module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av634-a94a2406894e644758fcae0fc888910e.jpg";